<template>
  <v-navigation-drawer fixed app clipped
    :mini-variant.sync="navMini"
    mini-variant-width="65"
    :width="$vuetify.breakpoint.mobile ? '100%' : 350"
    mobile-breakpoint="0"
    v-model="navOpen">

    <v-list-item class="px-2">
      <v-btn block text @click.stop="navMini = !navMini" class="d-flex justify-end" >
        <v-icon v-if="navMini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>

    <v-container>
      <v-row v-show="!navMini">
        <v-expansion-panels focusable accordion class="px-1">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>{{ $t('users.displayOptions') }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                  <GlobalOptions v-show="!navMini"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
      <v-row>
        <v-col class="pb-0 pt-0">
          <v-text-field data-lpignore="true" clearable
            v-model="filter"
            @keyup.enter="search"
            @click:clear="resetSearch"
            :error-messages="errors"
            class="filter-field"
            id="users-filter"
            v-show="!navMini"
            :placeholder="$t('tb.filter.placeholder')">
            <template v-slot:append-outer>
              <v-btn icon small color="primary" @click="search" v-show="!navMini">
                <v-icon>mdi-account-search-outline</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row class="scroll-y users-list">
        <v-col class="pa-0">
          <v-overlay absolute :value="loading">
            <v-progress-circular size="80" indeterminate>
            </v-progress-circular>
          </v-overlay>
          <v-list dense>
            <User v-for="(user, idx) in users" :key="idx" :user="user" />
          </v-list>
        </v-col>
      </v-row>

      <v-row align="end" justify="center" v-show="!navMini">
        <Pagination @loading="loading = !loading"/>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import User from './user'
import Pagination from './pagination'
import LocalStorage from 'Store/class/local_storage'
import events from 'Store/events'
import GlobalOptions from '@/components/buddies/global_options'

export default {
  name: 'users',
  data () {
    return {
      loading: false,
      errors: [],
      navOpen: true,
      paneMin: true,
      buddiesGlobalOptions: false
    }
  },
  components: { User, Pagination, GlobalOptions },
  mounted () {
    this.paneMin = !LocalStorage.isPaneUsersOn()
  },
  computed: {
    ...mapGetters({
      users: 'users/list',
      pagination: 'users/pagination'
    }),
    filter: {
      get () {
        return this.pagination.filter
      },
      set (filter) {
        this.setFilter(filter)
      }
    },
    navMini: {
      set: function (val) {
        LocalStorage.setPaneUsers(!val)
        this.paneMin = val
      },
      get: function () {
        return this.paneMin
      }
    }
  },
  methods: {
    ...mapActions({
      searchUsers: 'users/searchUsers',
      setFilter: 'users/setFilter'
    }),
    search: function () {
      this.searchLoadList(this.filter)
    },
    resetSearch: function () {
      this.filter = ''
      this.errors.splice(0)
      this.searchLoadList(null)
    },
    searchLoadList: function (filter) {
      this.loading = true
      this.searchUsers().catch(err => {
        events.pubError(`Failed to load users: ${err.type} (${err.exception})`)
        this.dbg(err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.v-navigation-drawer {overflow: hidden}
.v-navigation-drawer--mini-variant {cursor: pointer}
</style>
